import { getPathString, isObjectValueType } from '@helpers'
import { BIND_TYPE, EXPAND_FIELD_PREFIX, FIELD_VALUE_TYPE } from '@constants'

import { EmbeddedObject } from '@gantt/components/GanttCreateOrEdit'

type GetExpandsParamForDropdownParams = {
  fieldCode: string
  valueType: FIELD_VALUE_TYPE
  bindType?: BIND_TYPE
  pathArray?: EmbeddedObject[] | null
}

export const getExpandsParamForDropdown = ({
  fieldCode,
  valueType,
  bindType = BIND_TYPE.FIELD,
  pathArray,
}: GetExpandsParamForDropdownParams) => {
  const expands = new Set<string>()

  if (!fieldCode) {
    return []
  }

  if (pathArray?.length && bindType === BIND_TYPE.FIELD) {
    const pathsForExpand = pathArray.slice(0, -1)

    if (pathsForExpand.length) {
      pathsForExpand.unshift({
        field: fieldCode,
        valueType,
        objectCode: '',
        refValueType: valueType,
        type: 'single',
        isPk: false,
        isInternalId: false,
        model: null,
        internalId: null,
      })

      expands.add(
        `${getPathString(pathsForExpand)}:${getPathString(pathsForExpand, EXPAND_FIELD_PREFIX)}`
      )
    }
  }

  if (isObjectValueType(valueType)) {
    expands.add(`${fieldCode}:${EXPAND_FIELD_PREFIX}${fieldCode}`)
  }

  return [...expands]
}
